import {
  PopupMGReglesBtn,
  PopupNotifStartMinigameBtns,
} from "@/components/popups/PopupNotif/PopupNotifBtns"
import { makeAutoObservable } from "mobx"
import { DragDropFile } from "react-sdk/activities/DragDrop"
import { QCMFile } from "react-sdk/activities/QCM"
import { SwipeFile } from "react-sdk/activities/Swipe"
import { ReordonnerFile } from "react-sdk/activities/Reordonner"
import PopupsManager from "react-sdk/PopupsManager"
import Analytics from "react-sdk/Vertx/Analytics"
import AppState, { POPUPS } from "../AppState"
import Minigame from "./Minigame"
import MinigameFtues from "./MinigameFtues"
import DataManager, { DataUtils } from "react-sdk/haxelibs/DataManager"
import FtueHelper from "../FtueHelper"

export const MG_TYPES = {
  QUIZ: "quiz",
  DRAGDROP: "dragdrop",
  REORDER: "reorder",
  SWIPE: "swipe",
  SOKOBAN: "sokoban",
  CONNECTION_LINK: "connectionLink",
  LABYRINTH: "labyrinth",
}

class Minigames {
  /** @type {QCMFile} */
  qcms = null

  /** @type {DragDropFile} */
  dragdrops = null

  swipes = null

  reordonners = null

  /** @type {Array<Minigame>} */
  all = []

  currentLevelIndex = null
  /** @type {Minigame} */
  current = null

  onEnd = null

  history = []

  stars = 0
  maxStars = 0

  constructor() {
    makeAutoObservable(this)
  }

  init(minigamesFilename, files) {
    let {
      qcms,
      dragdrops,
      swipes,
      reordonners
    } = files



    this.qcms = new QCMFile(qcms)
    this.qcms.observeAll()

    this.dragdrops = new DragDropFile(dragdrops)
    this.dragdrops.observeAll()


    this.swipes = new SwipeFile(swipes)
    this.swipes.observeAll()

    this.reordonners = new ReordonnerFile(reordonners)
    this.reordonners.observeAll()

    let minigames = DataManager.getFile(minigamesFilename);

    this.all = minigames.lines.filter(line => line.id).map(line => new Minigame(line))

    this.all.forEach(mg => {
      let c = DataUtils.getChildren(mg.line, "parent");
      if (c && c.length > 0) {
        mg.children = c.map(childLine => this.get(childLine.id))
      }
    })

    this.maxStars = this.all.filter(mg => !mg.line.get("parent")).length * 3
  }

  get ids() {
    return this.all.map(c => c.id)
  }

  get(id) {
    return this.all.find(c => c.id === id)
  }

  get unlocked() {
    return this.all.filter(mg => mg.unlocked)
  }

  /**
   *
   * @param {string} id l'id de la ligne principale du mg dans le .data
   * @param {Function} onFinished callback appelée à la fin du mg
   */
  play(id, onFinished) {
    this.onEnd = onFinished

    let mg = this.get(id)
    if (!mg) {

      let tmp = this.onEnd
      if (this.onEnd) {
        this.onEnd = null
      }
      if (tmp) tmp()

      throw new Error(`Minigame ${id} does not exist`)    
    }

    // this.current = mg

    let datas = {
      title: mg.name,
      text: mg.description,
      image_url: mg.img_url,
      Buttons: PopupNotifStartMinigameBtns.bind(null, { mg }), // <-instance d'un component react avec des props
      onClose: () => {
        PopupsManager.close(POPUPS.NOTIF)
        // this.stop()
        // this.launch(mg)

        let tmp = this.onEnd
        if (this.onEnd) {
          this.onEnd = null
        }
        if (tmp) tmp()
      },
    }

    PopupsManager.open(POPUPS.NOTIF, datas)
  }

  /**
   *
   * @param {Minigame} minigame le minigame à lancer
   * @param {Function} onfinished callback appelée à la fin du mg
   */
  launch(minigame) {


    if (minigame.isContainer()) {
      this.currentGroup = minigame
      this.launchNextInGroup()
    } else {
      if (MinigameFtues.hasBeenViewed(minigame.type)) {
        this.reallyLaunch(minigame)
        return
      }

      const pages = MinigameFtues.getForMG(minigame.type)
      if (pages.length === 0) {

        this.reallyLaunch(minigame)
        return
      }



      // HACK on ajoute le bouton sur la dernière page
      pages.at(-1).Buttons = PopupMGReglesBtn



      /** @type {import("@/components/popups/PopupNotif/PopupNotif").NotifPopupOptions} */
      const data = { Pages: pages }



      PopupsManager.open(POPUPS.NOTIF, data, () => {
        // HACK on delete le bouton sur la dernière page
        delete pages.at(-1).Buttons
        this.reallyLaunch(minigame)
      })
    }
  }

  launchNextInGroup() {
    let currIndex = -1;
    if (this.current)
      currIndex = this.currentGroup.findCurrentMinigameIndex(this.current)

    ++currIndex;
    if (currIndex >= this.currentGroup.children.length) {
      this.history.push(this.currentGroup)
      this.currentGroup = null;
      let mg = this.current
      this.current = null;
      let tmp = this.onEnd
      if (this.onEnd) {
        this.onEnd = null
        // tmp()
      }


      if(mg.parent != null) {
        mg = this.get(mg.parent.lineId)
        let score = 0
        mg.children.forEach(ch => {
          score += ch.score
        })
        mg.setRawScore(score)
      }
      
      PopupsManager.open(POPUPS.MINIGAME_STARS, mg, () => { if (tmp) tmp() })
    } else {
      this.launch(this.currentGroup.children[currIndex])
    }

  }

  reallyLaunch(minigame) {
    this.current = minigame
    FtueHelper.handleftueButtonClick()

    Analytics.changeScreenEvents(null, "popup.MINIGAME." + this.current.id)
  }

  stop(score) {

    if (this.current) {
        this.current.setRawScore(score)

      Analytics.changeScreenEvents("popup.MINIGAME." + this.current.id)
    }

    if (this.currentGroup) {
      this.launchNextInGroup();
    } else {
      this.history.push(this.current)
      let mg = this.current
      this.current = null;
      let tmp = this.onEnd
      if (this.onEnd) {
        this.onEnd = null
      }


      // this.stars += mg.getStars()

      PopupsManager.open(POPUPS.MINIGAME_STARS, mg, () => { if (tmp) tmp() })
    }
  }

  // use to animate the score at the right time
  refreshGlobalScore() {
    let newCount = 0
    this.all.forEach(mg => {
      if(mg.parent || !mg.scoresHistoric || mg.scoresHistoric.length === 0) return

      newCount += mg.getStars()
    })

    this.stars = newCount
  }

  stateToJson() {

  }

  jsonToState() {

  }

}

export default new Minigames()